import { render, staticRenderFns } from "./MyReports.vue?vue&type=template&id=a308fba8"
import script from "./MyReports.vue?vue&type=script&lang=js"
export * from "./MyReports.vue?vue&type=script&lang=js"
import style0 from "./MyReports.vue?vue&type=style&index=0&id=a308fba8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports